import React, { FC, useState, useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { IonModal, IonContent, IonHeader, IonFooter, IonCheckbox } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { modalLayer, toast, useHistoryNew } from '@utils'
import { Icon, PrivacyAgreementModal, ServiceAgreementModal } from '@cps'
import './index.scss'

interface IProps extends RouteComponentProps {
  show: boolean;
  visitBack?: boolean;
  backdropShow?: boolean;
  backdropDismiss?: boolean;
  onClose?: () => void;
}
interface IState {
  agree: boolean;
}

const LoginModal: FC<IProps> = (props) => {
  const {
    show,
    visitBack,
    backdropShow = true,
    backdropDismiss = true,
    onClose,
    location
  } = props
  const history = useHistoryNew()

  const initialState: IState = {
    agree: true,
  }
  const [agree, setAgree] = useState(initialState.agree)
  // visit
  const handleVisit = () => {
    onClose && onClose()
    if (!(location && location.pathname.includes('/login')) && visitBack) {
      history && history.length < 2 ? history.push('/my') : history.goBack()
    }
    console.log('as visit login')
  }
  // facebook login

  // google login

  // emial || mobile login
  const handleEsLogin = () => {
    if (!agree) {
      toast({ message: i18n.t('mkt.common.tipPrivacy') })
      return
    }
    onClose && onClose()
    if (!(location && location.pathname.includes('/login'))) {
      history.push('/login')
    }
  }
  useEffect(() => {

  }, [show])
  return (
    <>
      <IonModal
        isOpen={show}
        cssClass='mkt-login-modal'
        showBackdrop={backdropShow}
        swipeToClose={backdropDismiss}
        backdropDismiss={backdropDismiss}
        onDidDismiss={handleVisit}
      >
        <IonHeader className='modal-header'>
          <i className='iconfont icon-close' data-cypid='mtkLoginModalClose' onClick={onClose}></i>
        </IonHeader>
        <IonContent>
          <div className='modal-content'>
            <div className='title'>{i18n.t('mkt.member.guideLoginReg')}</div>
            <div className='intro'>{i18n.t('mkt.member.guideLoginRegSub')}</div>
            <div className='type-content'>
              {/* {
                window.bo !== 'cn' &&
                  <>
                    <FacebookProvider appId={ENV.facebookAppId}>
                      <LoginButton
                        scope='email'
                        onCompleted={handleFbLogin}
                        onError={loginError}
                      >
                        <div className='type-item btn-facebook'>
                          <div className='start'>
                            <Icon name='facebook' />
                          </div>
                          <div className='end'>
                            {i18n.t('mkt.common.facebook')}
                          </div>
                        </div>
                      </LoginButton>
                    </FacebookProvider>
                    <div className='type-item btn-google'>
                      <GoogleLogin
                        clientId='976087053892-fige93uf6uogiv6jcpu1sq7d4feqsjuo.apps.googleusercontent.com'
                        buttonText='Login'
                        onSuccess={handleGgLogin}
                        onFailure={loginError}
                        cookiePolicy='single_host_origin'
                      />
                      <div className='start'>
                        <Icon name='google' />
                      </div>
                      <div className='end'>
                        {i18n.t('mkt.common.google')}
                      </div>
                    </div>
                  </>
              } */}
              <div className='type-item btn-account' data-cypid='mtkLoginModalEsLogin' onClick={handleEsLogin}>
                <div className='start'>
                  <Icon name='email' />
                </div>
                <div className='end'>
                  {window.bo === 'cn' ? i18n.t('mkt.common.mobile') : i18n.t('mkt.common.emailMobile')}
                </div>
              </div>
              <div className='type-item btn-account' data-cypid='mtkLoginModalVisit' onClick={handleVisit}>
                <div className='start'>
                  <Icon name='my' />
                </div>
                <div className='end'>
                  {i18n.t('mkt.member.guideVisit')}
                </div>
              </div>
            </div>
          </div>
        </IonContent>
        <IonFooter className='modal-footer'>
          {window.bo === 'us' &&
            <div className='agree'>
              <IonCheckbox className='checkbox' checked={agree} data-cypid='mtkLoginModalAgree' onClick={() => setAgree(!agree)} />
              {i18n.t('mkt.common.tipPrivacy2')}
              <span
                className='aggrement' data-cypid='mtkLoginModalPrivacyAgreement' onClick={(e: any) => {
                  e.stopPropagation()
                  modalLayer(PrivacyAgreementModal, null, 'privacyAgreementModal').then(() => {
                    setAgree(true)
                  })
                }}
              >
                {i18n.t('mkt.common.privacy')}
              </span>
              <span>{i18n.t('mkt.common.and')}</span>
              <span
                className='aggrement' data-cypid='mtkLoginModalServiceAgreement' onClick={(e: any) => {
                  modalLayer(ServiceAgreementModal, null, 'serviceAgreementModal').then(() => {
                    setAgree(true)
                  })
                }}
              >{i18n.t('mkt.common.service')}
              </span>
            </div>}
        </IonFooter>
      </IonModal>
    </>
  )
}

export default observer(withRouter(LoginModal))
